<template>
  <CoreCard
    class="p-4 h-full max-h-full"
    body-cls="h-full w-full flex flex-col"
  >
    <template #body>
      <div class="flex">
        <CoreText value="Rental Listings" />
        <ChartMaximizer v-if="showMaximize">
          <ChartRentalListings
            :show-maximize="false"
            :data="data"
            :chart-options="chartOptions"
          />
        </ChartMaximizer>
      </div>
      <VueApexCharts
        class="default-chart-pie"
        height="100%"
        :options="chartOptions"
        :series="data"
      />
    </template>
  </CoreCard>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";
import { CoreCard, CoreText } from "@purepm/core-ui";
import ChartMaximizer from "ui/components/ChartMaximizer.vue";

export default {
  name: "ChartRentalListings",
  components: {
    VueApexCharts,
    CoreCard,
    CoreText,
    ChartMaximizer,
  },
  props: {
    showMaximize: {
      type: Boolean,
      default: true,
    },
    chartOptions: {
      type: Object,
      required: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
